import React, { useEffect, useRef } from 'react';
import WebViewer from '@pdftron/webviewer';
import { useLocation } from 'react-router-dom';
import { API } from "../../config/api";
import { ApiHelper } from '../../helpers/ApiHelper';
import { useNavigate } from 'react-router-dom';

const ConvertDocument = () => {
  const navigate = useNavigate();
  const viewer = useRef(null);
  const location = useLocation();
  const blobData = location.state && location.state.blobData;
  const fileName = location.state && location.state.fileName;
  let user = JSON.parse(localStorage.getItem('UserData'));
  useEffect(() => {
    WebViewer(
        {
            path: '/webviewer/lib',
            licenseKey: 'demo:1693484487859:7c3fdd7a0300000000750d576a730d03a6c0bc632112dcba418691149a',
        },
        viewer.current
    ).then((instance) => {
        const { documentViewer, annotationManager, Annotations } = instance.Core;

        // Log when the documentLoaded event is fired
        documentViewer.addEventListener('documentLoaded', () => {
            console.log('Document loaded!');
        });
        instance.UI.loadDocument(blobData, { filename: fileName });

        instance.UI.setHeaderItems((header) => {
            header.push({
                type: 'actionButton',
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                onClick: async () => {
                    const xfdfString = await annotationManager.exportAnnotations();
                    const doc = documentViewer.getDocument();
                    doc.getFileData({ xfdfString }).then(data => {
                            const arr = new Uint8Array(data);
                            try{
                                const base64String = btoa(String.fromCharCode.apply(null, arr));
                                const formData = new FormData();    
                                formData.append('filebufferencrypted', base64String);
                                formData.append('filebuffxml', xfdfString);
                                formData.append('title', fileName);
                                formData.append('subtitle', 'converted document');
                                formData.append('chatbotid', '287');
                                formData.append('userid', user.id);
                                ApiHelper.post(API.saveConvertDocument, formData).then((res)=>{
                                if(res){
                                   navigate('/dashboard/upload');
                                }   
                                alert('file send successfully');
                            }).catch((err)=>{
                               console.log('err',err);
                            })
                            }catch(err){
                                console.log('base64 array err',err);
                            }
                            
                      })
              },
            });
        });
    });
}, [blobData]);

  return <div className="webviewer" style={{ height: '800px',marginTop: '100px' }}ref={viewer}></div>;
};

export default ConvertDocument;